
import { Component, OnInit, Input, ViewChild, Injectable, ElementRef } from '@angular/core';

import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { matchingPasswords, emailValidator } from 'src/app/theme/utils/app-validators';
import { DomSanitizer } from '@angular/platform-browser';
import { UserServiceService } from 'src/app/services/user-service.service';
import { EmailService } from 'src/app/services/Email.service';

import { FacebookLoginProvider, GoogleLoginProvider, SocialAuthService } from '@abacritt/angularx-social-login';
import { ToastrService } from 'ngx-toastr';
import { LoginserviceService } from 'src/app/services/loginservice.service';
import { AuthService } from '../../services/auth.service';
import { HostService } from 'src/app/services/host.service';



@Component({
  selector: 'app-create-utilisateurs',
  templateUrl: './create-utilisateurs.component.html',
  styleUrls: ['./create-utilisateurs.component.scss']
})

@Injectable({
  providedIn: 'root'
})
export class CreateUtilisateursComponent implements OnInit {
  [x: string]: any;
  public CreateUtilisateurForm!: UntypedFormGroup | any;
  public hide = true;
  idUser: number | any;
  val: any;
  valid: any;
  public bgImage: any;
  public data: any;
  public googleImage: any;
  public item: any;
  public userItem: any;

  constructor(
    public formBuilder: UntypedFormBuilder,
    private toastr: ToastrService,

    private authService: SocialAuthService,
    private auth: AuthService,
    public service: UserServiceService,
    public EmailServices: EmailService,
    public router: Router,
    public loginService: LoginserviceService,
    public snackBar: MatSnackBar,
    private sanitizer: DomSanitizer,
    public hostService:HostService) { }
  ngOnInit() {

    this.bgImage = this.sanitizer.bypassSecurityTrustStyle("url("+this.hostService.getHttpsImage()+"images/others/inscription.png");
    this.googleImage = this.sanitizer.bypassSecurityTrustStyle('url(assets/images/others/google.png)');

    const storageInfoUserCreated= localStorage.getItem("infoUserCreated");
    
    if (storageInfoUserCreated) {

      this.CreateUtilisateurForm = this.formBuilder.group(
        {
          email: [JSON.parse(storageInfoUserCreated).email,Validators.compose([Validators.required,Validators.pattern(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})|\+221|\+33\d{9}$/),]),],
          //mobileNumber: ['', [Validators.required, Validators.pattern("^((\\+221-?)|0)?[0-9]{10}$")]] ,
          password: [JSON.parse(storageInfoUserCreated).password, Validators.required],
          confirmPassword: [JSON.parse(storageInfoUserCreated).confirmPassword, Validators.required],
          AceptCondition: [JSON.parse(storageInfoUserCreated).AceptCondition, Validators.required],
        },
        { validator: matchingPasswords("password", "confirmPassword") }
      );

    } else {

      this.CreateUtilisateurForm = this.formBuilder.group(
        {
          email: [null,Validators.compose([Validators.required,Validators.pattern(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})|\+221|\+33\d{9}$/),]),],
          //mobileNumber: ['', [Validators.required, Validators.pattern("^((\\+221-?)|0)?[0-9]{10}$")]] ,
          password: ["", Validators.required],
          confirmPassword: ["", Validators.required],
          AceptCondition: [false, Validators.required],
        },
        { validator: matchingPasswords("password", "confirmPassword") }
      );

    }
   

     //verifier si un profil existe dans la sessions
     const storageAuth = localStorage.getItem("user");
     if (storageAuth) {
       this.userDetails = JSON.parse(storageAuth);
       this.router.navigateByUrl("/");
       console.log(this.userDetails);   
     }
    
  }


  public onCreateUtilisateurFormSubmit(): void {

    //Supprimons les info misent dans le storage
    localStorage.removeItem("infoUserCreated");
    localStorage.clear();

    let obj = {
      //  email: this.data.email,
      //  password: this.data.password,
      email: this.CreateUtilisateurForm.get('email').value,
      password: this.CreateUtilisateurForm.get('password').value,
    }

    this.data = this.CreateUtilisateurForm.value;
    this.valid = this.CreateUtilisateurForm.get('email').value;
    ///
    this.email = this.CreateUtilisateurForm.get('email').value;
    this.password = this.CreateUtilisateurForm.get('password').value;
    if (this.CreateUtilisateurForm.valid) {
    
       this.auth.register(this.email,this.password);

    }
  }

  public readCGU() {

    localStorage.setItem("infoUserCreated", JSON.stringify(this.CreateUtilisateurForm.value));

    this.router.navigateByUrl("/terms-conditions");

  }
}
